import script from "./ExternalLogInRedirect.vue?vue&type=script&lang=js"
export * from "./ExternalLogInRedirect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__